import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const RELATED_CTA = {
  iv: { label: "Explore IV Therapy", to: "/iv-therapy" },
  consult: { label: "Book a Consult", to: "/book/consult" },
  shop: { label: "Shop Supplements", to: "/shop" },
  membership: { label: "Explore Memberships", to: "/memberships" },
};

export default function GuideArticle() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/articles/${slug}`).then(({data})=>setA(data)).catch(()=>setErr(true)); }, [slug]);
  if (err) return <div className="section-y container-x">Article not found. <Link to="/guide" className="text-sage-700">Back to Guide</Link></div>;
  if (!a) return <div className="section-y container-x text-sage-700/60">Loading…</div>;
  const cta = RELATED_CTA[a.related_service] || RELATED_CTA.consult;
  return (
    <article className="section-y" data-testid="article-page">
      <div className="container-x max-w-3xl">
        <Link to="/guide" className="text-sm text-sage-700">← Back to the Restore Guide</Link>
        <div className="overline mt-4 text-clay-600">{a.category}</div>
        <h1 className="font-display text-4xl lg:text-5xl text-sage-800 mt-3">{a.title}</h1>
        {a.cover_image && <div className="mt-8 rounded-3xl overflow-hidden aspect-[16/9]"><img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" /></div>}
        <div className="mt-10 text-sage-800/80 leading-relaxed whitespace-pre-wrap text-[17px]">{a.body}</div>

        <div className="mt-14 rounded-3xl bg-sand-100 border border-sand-200/70 p-7 flex flex-wrap items-center justify-between gap-4">
          <div>
            <div className="overline">Interested?</div>
            <div className="font-display text-xl text-sage-800 mt-1">{cta.label}</div>
          </div>
          <Button asChild className="btn-pill h-11 px-6 bg-sage-700 hover:bg-sage-800 text-white"><Link to={cta.to}>{cta.label}</Link></Button>
        </div>
      </div>
    </article>
  );
}
